export default __webpack_public_path__ + "c4f453363b529e298c317675ca8dfbd4.jpg";